let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("69dSh")).then(() => parcelRequire('fuev4'));